/**
 * Moderation Total Cases Panel
 *
 * Displays the total number of moderation cases with change indicator
 */

import { Shimmer, Text } from '@soteria/design-system-ve';

import * as styles from './ModerationStatsPanel.css';

interface ModerationTotalCasesPanelProps {
  totalCases: number;
  change?: number;
  isLoading?: boolean;
}

export function ModerationTotalCasesPanel({ totalCases, change, isLoading = false }: ModerationTotalCasesPanelProps) {
  if (isLoading) {
    return (
      <div className={styles.panel}>
        <div className={styles.header}>
          <span className={styles.title}>TOTAL CASES</span>
        </div>
        <div className={styles.content}>
          <Shimmer className={styles.shimmerValue} label="Loading total cases count" />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <span className={styles.title}>TOTAL CASES</span>
      </div>
      <div className={styles.content}>
        <Text as="div" className={styles.value}>
          {totalCases.toLocaleString()}
        </Text>
        {change !== undefined && (
          <Text as="div" className={styles.subtitle}>
            {change > 0 ? '+' : ''}
            {change} last 24h
          </Text>
        )}
      </div>
    </div>
  );
}
